import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateHirePurchasePdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  assets,
  assetCodeList,
  summaryData,
  caTypeTotals,
  notes,
  reviewNotes,
  showDecimals = false,
}) => {
  const sharedArgs = [
    schedule,
    company,
    assets,
    assetCodeList,
    summaryData,
    caTypeTotals,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) =>
          generateHirePurchasePdf(forView, ...sharedArgs, false, showDecimals)
        }
        downloadName='Hire Purchase'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateHirePurchasePdf(forView, ...sharedArgs, true, showDecimals)
        }
      />
    </>
  );
};

export default PdfGenerator;
